module.exports = __webpack_public_path__ + "img/nync.814ac532.png";